var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled)?_c('div',{staticClass:"jeecg-form-container-disabled"},[_c('fieldset',{attrs:{"disabled":""}},[_vm._t("default")],2)]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }